import React, { useState, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { Form, Input } from '@rocketseat/unform';
import { MdSave } from 'react-icons/md';

import { toast } from 'react-toastify';

import api from '~/services/api';
import history from '~/services/history';

import { Container, Content, Bloco, Grid, BForm } from './styles';

import { usePermission } from '~/hooks/permission';
import Carregando from '~/components/Carregando/Button';
import User from '~/components/User';
import Title from '~/components/Title';
import Footer from '~/components/Footer';
import Nav from '~/components/Navigation';

export default function Adicionar() {
  const [loading, setLoading] = useState(false);
  const profile = useSelector(state => state.user.profile);
  const { adminAcessoPermission } = usePermission();
  adminAcessoPermission({ role_id: profile.role_id });

  const handleSubmit = useCallback(async ({ title }) => {
    try {
      setLoading(true);
      await api.post('roles', {
        title,
      });

      setLoading(false);
      toast.success('Permissão cadastrado com sucesso.');
      history.push('/permissoes');
    } catch (err) {
      setLoading(false);
      toast.error('Algo deu errado no cadastro.');
    }
  }, []);

  return (
    <>
      <Nav page="administracao" />

      <Container>
        <User />

        <Content>
          <Title title="Administrador / Permissão / Adicionar" />

          <Bloco>
            <div>
              <h2>Adicionar permissão</h2>
            </div>
          </Bloco>
        </Content>

        <Grid>
          <Form onSubmit={handleSubmit}>
            <BForm>
              <span>
                <label>Permissão</label>
                <Input type="text" name="title" />
              </span>
            </BForm>
            <BForm>
              <span>
                <button type="submit" className="btn-save">
                  {loading ? (
                    <Carregando />
                  ) : (
                    <>
                      <MdSave size={16} color="#fff" /> Salvar
                    </>
                  )}
                </button>
              </span>
            </BForm>
          </Form>
        </Grid>

        <Footer />
      </Container>
    </>
  );
}
